<template>
  <div class="navbar navbar-toggleable-sm custom-navbar">
    <div class="navbar-brand">
      <!--<img src="../../assets/img/autoIX_logo.png" alt="autoix-logo" height="45px" class="navbar-brand">-->
    </div>
    
    
    <div class="menu-title">
      <p>{{ currentApp.name }}</p>
    </div>
    <div class="ml-auto menu-info">
      <span id="greeting" v-if="user !== null || user !== undefined">{{ GreetingMsg }}, 
        <span v-if="user.first_name !== null && user.last_name !== null">{{user.last_name}}{{ user.first_name }}</span>
        <span v-else>{{ user.username }}</span>
        <span v-if="user.title  !== null">{{ user.title.name }}</span>
      </span>
    </div>
    
    <div class="logout-button" @click="logout" v-if="showLogout">登出</div>
    <!-- <clock v-else /> -->
  </div>
</template>

<script>
import moment from 'moment';
import Clock from './Clock';

export default {
  name: 'navbar',
  components: {
    Clock,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    currentApp() {
      return this.$store.state.currentApp;
    },
    GreetingMsg() {
      const hourNow = moment().hour();
      if (hourNow >= 5 && hourNow < 11) {
        return '早安';
      }
      if (hourNow >= 11 && hourNow <= 17) {
        return '午安';
      }
      return '晚安';
    },
    showLogout() {
      return this.$store.state.showLogout;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('setOffline');
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Login' });
    },
  },
  watch: {
    // user(val) {
    //   if (val === null || val === undefined) {
    //     this.$store.dispatch('getUser');
    //   }
    // },
  },
};

</script>

<style lang="sass">
.custom-navbar
  margin: 0 -15px;
  background: #f4f4f4;
  // border-radius: 10px 10px 0px 0px;
  border-bottom: 1px solid rgba(0,0,0,0.05);

.menu-title
  display: flex;
  align-items: center
  border-bottom: 2px solid cadetblue;
  position: absolute;
  left: 460px
  p
    margin: 0
    font-size: 20px

.menu-info
  #greeting
    margin-right: 10px
    font-size: 14px
    color: salmon

.logout-button
  margin: -10px -17px -10px 0;
  height: 72px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FF3811;
  // border-radius: 0 10px 0 0;
  color: white
  font-weight: 500
</style>



// WEBPACK FOOTER //
// Navbar.vue?3c18845e